import { ApolloProvider } from '@apollo/client';

import { ThemeConfig } from './theme';
import AppRouter from './view/AppRouter';
import apolloClient from './core/apolloClient';
import EMenuRouter from './view/E-MenuRouter';

function App() {
  const path = window.location.pathname;
  return (
    <ApolloProvider client={apolloClient}>
      <ThemeConfig>
        {path.startsWith('/e-menu') ? <EMenuRouter /> : <AppRouter />}
        {/* <AppRouter /> */}
      </ThemeConfig>
    </ApolloProvider>
  );
}

export default App;
